<template>
  <div class="container">
    <h1 class="py-4">アプリ会員管理</h1>
    <div class="pb-4">
      <div class="form-row">
        <div class="form-group col-md-4">
          <label for="l-pid">契約番号</label><br />
          <input v-model="contract" placeholder="契約番号" class="input-boot" />
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">代表契約番号</label><br />
          <input
            v-model="contractrep"
            placeholder="代表契約番号"
            class="input-boot"
          />
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">電話番号</label><br />
          <input
            v-model="telephone"
            placeholder="電話番号"
            class="input-boot"
          />
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">携帯電話番号</label><br />
          <input
            v-model="mobile"
            placeholder="携帯電話番号"
            class="input-boot"
          />
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">カナ英字氏名</label><br />
          <input v-model="name" placeholder="カナ英字氏名" class="input-boot" />
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">漢字氏名</label><br />
          <input
            v-model="kanjiname"
            placeholder="漢字氏名"
            class="input-boot"
          />
        </div>
      </div>
      <div class="form-group col-md-12">
        <input v-model="choysanAccountOnly" type="checkbox" />
        c.choysanアカウントと連携しているユーザのみ表示
      </div>
      <div class="text-right">
        <button class="btn btn-primary mr10" @click="clear">クリア</button>
        <button class="btn btn-primary" @click="search">検索</button>
      </div>
      <div class="form-row">
        <div class="form-group col-md-auto">
          <input type="file" id="csvUpload" @change="readFile" hidden />
          <button disabled class="btn btn-primary" @click="openCSV">
            CSV インポート
          </button>
        </div>
        <div class="form-group col-md-auto">
          <vue-json-to-csv
            :labels="this.csvCurrentFields"
            :json-data="this.usersCsv"
            :csv-title="this.fileName"
          >
            <button class="btn btn-success" @click="csv">
              CSV ダウンロード
            </button>
          </vue-json-to-csv>
        </div>
      </div>
    </div>
    <div :key="key">
      <div v-if="loading" class="form-row">
        <b-spinner
          class="autoMarginLR"
          variant="primary"
          label="Spinning"
        ></b-spinner>
      </div>
      <div v-if="!loading" class="table-responsive">
        <b-table
          id="userTable"
          :items="users"
          :per-page="perPage"
          :current-page="currentPage"
          small
        >
          <template #cell(契約番号)="data">
            <router-link
              :to="{
                name: 'ContractDetails',
                query: { contractId: data.item.契約番号 },
              }"
              target="_blank"
              >{{ data.item.契約番号 }}</router-link
            >
          </template>
        </b-table>
        <b-pagination
          class="mt30"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          aria-controls="userTable"
        ></b-pagination>
      </div>
    </div>
    <modal name="confirm" :adaptive="true" width="50%" height="50%">
      <div class="centered-modal">
        <p class="loadingp">{{ this.importCount }} 件インポートしました。</p>
        <button class="btn btn-primary" @click="closeConfirm">完了</button>
      </div>
    </modal>
    <modal name="error" :adaptive="true" width="50%" height="50%">
      <div class="centered-modal">
        <p class="loadingp">{{ this.errormsg }}</p>
        <button class="btn btn-primary" @click="closeError">とじる</button>
      </div>
    </modal>
    <modal
      name="loading"
      :clickToClose="false"
      :adaptive="true"
      width="50%"
      height="50%"
    >
      <div class="centered-modal">
        <p class="loadingp">インポート中</p>
        <div class="loading-spacer"></div>
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
    </modal>
    <modal
      name="duplicatedEntry"
      :clickToClose="false"
      :adaptive="true"
      width="50%"
      height="50%"
    >
      <div class="text-center-modal">
        <p>既に同じデータが存在します。</p>
        <p>新規ユーザまた更新データのみ追加します。</p>
        <div>
          <button
            class="btn btn-secondary buttonSetWidth mr20"
            @click="closeDuplicate"
          >
            キャンセル
          </button>
          <button
            class="btn btn-primary buttonSetWidth ml20"
            @click="writeData"
          >
            実行
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import master from "@/constants/MasterEnum";
import utils from "@/utils/Utils";
import firebase from "firebase";
import VueJsonToCsv from "vue-json-to-csv";
import prefs from "@/constants/PrefsEnum";
import countries from "@/constants/CountriesEnum";

export default {
  name: "ApplicationManagement",
  mixins: [utils, master, prefs, countries],
  computed: {
    rows() {
      return this.users.length;
    },
  },
  watch: {
    /*     currentPage(value) {
      sessionStorage.currentPage = value;
    }, */
  },
  data() {
    return {
      csvCurrentFields: {},
      currentPage: 1,
      perPage: 10,
      currentPageAppDuplication: 1,
      perPageAppDuplication: 10,
      fileName: "",
      labels: [],
      loading: true,
      choysanAccountOnly: false,
      users: [],
      usersCache: [],
      duplicatedDataApp: [],
      duplicatedDataSettlements: [],
      applicationUsersArray: [],
      userSettlementsArray: [],
      logArray: [],
      usersCsv: [],
      db: firebase.firestore(),
      name: "",
      kanjiname: "",
      contract: "",
      contractrep: "",
      mobile: "",
      telephone: "",
      importCount: 0,
      key: 0,
      errormsg: "",
    };
  },
  components: {
    VueJsonToCsv,
  },
  created: function() {
    this.labels = this.tsvFormat.bankitInfo.labels;
    /* let minutes = 5;
    let saved = sessionStorage.getItem("saved");
    if (saved && new Date().getTime() - saved > minutes * 60 * 1000) {
      sessionStorage.clear();
    }
    let usersSessionStorage = sessionStorage.getItem("users");
    let usersCsvStorage= sessionStorage.getItem("usersCsvManagement"); // If couldn't make a copy of the csv file just reset the data
    if (usersCsvStorage !== null) {
      this.users = JSON.parse(usersSessionStorage);
      this.usersCache=sessionStorage.getItem("usersCache")!==null ? JSON.parse(sessionStorage.getItem("usersCache")):[];
      this.usersCsv=sessionStorage.getItem("usersCsvManagement")!==null ? JSON.parse(sessionStorage.getItem("usersCsvManagement")):[];
      this.csvCurrentFields=JSON.parse(sessionStorage.getItem("csvFieldsApp"));
      this.currentPage =
        sessionStorage.currentPage == null ? 1 : sessionStorage.currentPage;
      this.name = sessionStorage.name == "" ? "" : sessionStorage.name;
      this.kanjiname =
        sessionStorage.kanjiname == "" ? "" : sessionStorage.kanjiname;
      this.contract =
        sessionStorage.contract == "" ? "" : sessionStorage.contract;
      this.contractrep =
        sessionStorage.contractrep == "" ? "" : sessionStorage.contractrep;
      this.mobile = sessionStorage.mobile == "" ? "" : sessionStorage.mobile;
      this.telephone =
        sessionStorage.telephone == "" ? "" : sessionStorage.telephone;
      this.fileName=sessionStorage.managementFileName;
      this.loading = false;
    } else { */
    this.loadCollection();
    //}
  },
  methods: {
    orderByContractNumber(a, b) {
      if (a.契約番号 > b.契約番号) {
        return 1;
      } else if (a.契約番号 < b.契約番号) {
        return -1;
      }
      return 0;
    },
    csv() {
      if (this.fileName == "pointUsers") {
        //this.addPointToUsers();
      }
    },
    resetImportArray() {
      this.duplicatedDataApp = [];
      this.duplicatedDataSettlements = [];
      this.applicationUsersArray = [];
      this.userSettlementsArray = [];
    },
    init() {
      this.users = [];
      this.usersCsv = [];
      this.key = this.key ? 0 : 1;
    },
    englishField(fieldNameJp) {
      return this.fields[fieldNameJp];
    },
    clear() {
      this.contract = "";
      this.contractrep = "";
      this.mobile = "";
      this.telephone = "";
      this.name = "";
      this.kanjiname = "";
      this.choysanAccountOnly = false;
      this.init();
      this.loadCollection();
    },
    search() {
      let searchParams = {
        contract_number: this.contract,
        representative_contract_number: this.contractrep,
        mobile: this.mobile,
        telephone: this.telephone,
        kanji_name: this.kanjiname,
        kana_name: this.name,
      };
      this.loadCollection(searchParams);
    },
    filterPopInfoId() {
      this.loadCollection(null, "popinfoId");
    },
    filterPoint() {
      this.loadPointUsers();
    },
    closeError() {
      this.$modal.hide("error");
    },
    closeConfirm() {
      this.$modal.hide("confirm");
    },
    closeDuplicate() {
      this.$modal.hide("duplicatedEntry");
    },
    closeLoading() {
      this.$modal.hide("loading");
    },
    openCSV() {
      document.getElementById("csvUpload").click();
    },
    modalLoading() {
      this.$modal.show("loading");
    },
    /*    async addPointToUsers() {
      let batch;
      let operationCount = 0;
      batch = this.db.batch();
      this.users.forEach(async (user) => {
        try {
          let usersPointRef = this.db.collection("usersPoints").doc();
          let data = {
            contract_number: user.契約番号,
            point: 100,
            point_add_date: "20201201",
            point_add_type: "01",
            point_type: "000",
            campaign_name: "Choy-Sanポイント",
            created_at: firebase.firestore.FieldValue.serverTimestamp(),
          };
          batch.set(usersPointRef, data);
          operationCount++;
          if (operationCount == 499) {
            await batch.commit();
            operationCount == 0;
            batch = this.db.batch();
          }
        } catch (error) {
          // empty
        }
      });
      await batch.commit();
    }, */
    readFile() {
      var file = event.target.files[0];
      //let fileNameCorrect = file.name.includes('契約番号別明細データ')||file.name.includes('契約番号別明細データ');
      let fileNameSplit = file.name.split(".");
      let fileFormat = fileNameSplit[fileNameSplit.length - 1];
      // Check if file is csv and if is master data
      if (fileFormat == "csv") {
        this.modalLoading();
        this.$papa.parse(file, {
          header: true,
          encoding: "Shift-JIS",
          skipEmptyLines: true,
          transformHeader: (header) => {
            return this.englishField(header);
          },
          complete: async (results) => {
            await this.buildData(results);
          },
        });
      } else {
        // wrong file format
        this.errormsg = "このファイル形式はインポートできません。";
        this.$modal.show("error");
      }
      event.target.value = null;
    },
    verifyCsvFields(results) {
      if (results.data[0].undefined !== undefined) {
        // if true wrong fields names in csv files (unknown fields added or renamed)
        return false;
      }
      this.verificationFields.forEach((key) => {
        // if missing fields
        if (results.data[0][key] == undefined) {
          return false;
        }
      });
      return true;
    },
    async fillArray(results) {
      let appCollection = await this.db.collection("applicationUsers").get();
      let appUsersArray = [];
      appCollection.docs.forEach((doc) => {
        appUsersArray[doc.id] = doc.data();
      });
      let err = false;
      let firebaseTimestamp = firebase.firestore.FieldValue.serverTimestamp();
      results.data.forEach(async (element, index, array) => {
        if (element.undefined !== undefined) {
          // if true wrong fields names in csv files (unknown fields added or renamed)
          err = true;
        }
        this.verificationFields.forEach((key) => {
          // if missing fields
          if (element[key] == undefined) {
            err = true;
          }
        });
        try {
          let applicationUserData = {};
          let year = element.data_created_at.slice(0, 4);
          let month = element.data_created_at.slice(4, 6);
          let day = element.data_created_at.slice(6, 8);
          let date = new Date(
            year + "-" + month + "-" + day + "T12:00:00+09:00"
          );
          let year2 = element.date_created.slice(0, 4);
          let month2 = element.date_created.slice(4, 6);
          let date2 = new Date(year2 + "-" + month2 + "-01T12:00:00+09:00");
          applicationUserData.data_created_at = element.data_created_at;
          applicationUserData.data_created_at_dateformat = date;
          applicationUserData.date_created_dateformat = date2;
          applicationUserData.customer_number = element.customer_number;
          applicationUserData.created_at = firebaseTimestamp;
          applicationUserData.date_created = element.date_created;
          applicationUserData.contract_number = element.contract_number;
          applicationUserData.entry_number = element.entry_number;
          applicationUserData.identification = element.identification;
          applicationUserData.representative_contract_number =
            element.representative_contract_number;
          applicationUserData.popinfoId = element.popinfoId;
          applicationUserData.branch_number = element.branch_number;
          applicationUserData.account_balance = element.account_balance;
          applicationUserData.account_type = element.account_type;
          applicationUserData.account_number = element.account_number;
          applicationUserData.account_number_branch =
            element.account_number_branch;
          applicationUserData.authentication_a = element.authentication_a;
          applicationUserData.a_date_confirmation = element.a_date_confirmation;
          applicationUserData.authentication_b = element.authentication_b;
          applicationUserData.b_date_confirmation = element.b_date_confirmation;
          applicationUserData.brand_id = element.brand_id;
          applicationUserData.grade_id = element.grade_id;
          applicationUserData.card_type = element.card_type;
          applicationUserData.usage_limit_1_time = element.usage_limit_1_time;
          applicationUserData.usage_limit_day = element.usage_limit_day;
          applicationUserData.usage_limit_month = element.usage_limit_month;
          applicationUserData.usage_limit_1_time_overseas =
            element.usage_limit_1_time_overseas;
          applicationUserData.usage_limit_day_overseas =
            element.usage_limit_day_overseas;
          applicationUserData.usage_limit_month_overseas =
            element.usage_limit_month_overseas;
          applicationUserData.withdraw_limit_1_overseas =
            element.withdraw_limit_1_overseas;
          applicationUserData.withdraw_limit_day_overseas =
            element.withdraw_limit_day_overseas;
          applicationUserData.withdraw_limit_month_overseas =
            element.withdraw_limit_month_overseas;
          applicationUserData.contract_date = element.contract_date;
          applicationUserData.cancellation_date = element.cancellation_date;
          applicationUserData.valid_member_flag = element.valid_member_flag;
          applicationUserData.contract_update_day = element.contract_update_day;
          applicationUserData.transaction_purpose = element.transaction_purpose;
          applicationUserData.transaction_purpose_other =
            element.transaction_purpose_other;
          applicationUserData.occupation = element.occupation;
          applicationUserData.occupation_other = element.occupation_other;
          applicationUserData.data_entry_date = element.data_entry_date;
          applicationUserData.postal_code = element.postal_code;
          applicationUserData.address1 = element.address1;
          applicationUserData.address2 = element.address2;
          applicationUserData.telephone = element.telephone;
          applicationUserData.mobile = element.mobile;
          applicationUserData.customer_update_day = element.customer_update_day;
          applicationUserData.kana_name = element.kana_name;
          applicationUserData.kanji_name = element.kanji_name;
          applicationUserData.emboss = element.emboss;
          applicationUserData.gender = element.gender;
          applicationUserData.birthday = element.birthday;
          applicationUserData.card_expiration = element.card_expiration;
          applicationUserData.last_good_through = element.last_good_through;
          applicationUserData.application_date = element.application_date;
          applicationUserData.card_issuance_instruction_date =
            element.card_issuance_instruction_date;
          applicationUserData.card_shipping_date = element.card_shipping_date;
          applicationUserData.link_origin = element.link_origin;
          applicationUserData.rankup_date = element.rankup_date;
          applicationUserData.card_issuance_date = element.card_issuance_date;

          if (element.telephone != "")
            applicationUserData.telephone_0 = "0" + element.telephone;
          if (element.mobile != "")
            applicationUserData.mobile_0 = "0" + element.mobile;
          this.applicationUsersArray.push(applicationUserData);

          // import log
          if (appUsersArray[element.contract_number] !== undefined) {
            var data = appUsersArray[element.contract_number];
            // compare new data and existing data and determine different fields
            // remove fields non existing in csv
            delete data.mobile_0;
            delete data.telephone_0;
            delete data.date_created_dateformat;
            delete data.data_created_at_dateformat;
            delete data.created_at;
            delete data.data_created_at;
            let updatedData = this.findNewData(data, element);
            if (updatedData.length !== 0) {
              let updatedFields = {};
              for (let key of updatedData) {
                updatedFields["from_" + key] = data[key];
                updatedFields["to_" + key] = element[key];
              }
              updatedFields.contract_number = element.contract_number;
              updatedFields.updated_at = firebaseTimestamp;
              /*               let copy=updatedData.filter(item=>item!=='occupation' && item!=='occupation_other');

              if(updatedData.includes("occupation") || updatedData.includes("occupation_other")){
                updatedFields.contract_update_day = element.contract_update_day;
              }
              if(copy.length!==0){
                updatedFields.customer_update_day = element.customer_update_day;
              } 
              */
              this.logArray.push(updatedFields);
            }
          }

          let settlementData = {};
          let yearDateCreated = element.date_created.slice(0, 4);
          let monthDateCreated = element.date_created.slice(4, 6);
          settlementData.contract_number = element.contract_number;
          settlementData.data_created_at_dateformat = date;
          settlementData.date_created_dateformat = date2;
          settlementData.created_at = firebaseTimestamp;
          settlementData.date_created = element.date_created;
          settlementData.data_created_at = element.data_created_at;
          settlementData.year = yearDateCreated;
          settlementData.month = monthDateCreated;

          settlementData.domestic_shopping_number =
            element.domestic_shopping_number;
          settlementData.domestic_shopping_amount =
            element.domestic_shopping_amount;
          settlementData.domestic_shopping_flag =
            element.domestic_shopping_flag;

          settlementData.overseas_shopping_number =
            element.overseas_shopping_number;
          settlementData.overseas_shopping_amount =
            element.overseas_shopping_amount;
          settlementData.overseas_shopping_flag =
            element.overseas_shopping_flag;

          settlementData.qr_payment_amount = element.qr_payment_amount;
          settlementData.qr_payment_number = element.qr_payment_number;
          settlementData.qr_payment_flag = element.qr_payment_flag;

          settlementData.atm_withdrawal_amount = element.atm_withdrawal_amount;
          settlementData.atm_withdrawal_number = element.atm_withdrawal_number;
          settlementData.atm_withdrawal_flag = element.atm_withdrawal_flag;

          settlementData.otasuke_charge_deposit_amount =
            element.otasuke_charge_deposit_amount;
          settlementData.otasuke_charge_deposit_number =
            element.otasuke_charge_deposit_number;
          settlementData.otasuke_charge_deposit_flag =
            element.otasuke_charge_deposit_flag;

          settlementData.otasuke_charge_repayment_amount =
            element.otasuke_charge_repayment_amount;
          settlementData.otasuke_charge_repayment_number =
            element.otasuke_charge_repayment_number;
          settlementData.otasuke_charge_repayment_flag =
            element.otasuke_charge_repayment_flag;

          settlementData.deposit_gather_amount = element.deposit_gather_amount;
          settlementData.deposit_gather_number = element.deposit_gather_number;
          settlementData.deposit_gather_flag = element.deposit_gather_flag;

          settlementData.withdrawal_gather_amount =
            element.withdrawal_gather_amount;
          settlementData.withdrawal_gather_number =
            element.withdrawal_gather_number;
          settlementData.withdrawal_gather_flag =
            element.withdrawal_gather_flag;

          settlementData.credit_charge_amount = element.credit_charge_amount;
          settlementData.credit_charge_number = element.credit_charge_number;
          settlementData.credit_charge_flag = element.credit_charge_flag;

          settlementData.atm_deposit_amount = element.atm_deposit_amount;
          settlementData.atm_deposit_number = element.atm_deposit_number;
          settlementData.atm_deposit_flag = element.atm_deposit_flag;

          settlementData.transfer_deposit_amount =
            element.transfer_deposit_amount;
          settlementData.transfer_deposit_number =
            element.transfer_deposit_number;
          settlementData.transfer_deposit_flag = element.transfer_deposit_flag;

          settlementData.main_sub_transfer_deposit_amount =
            element.main_sub_transfer_deposit_amount;
          settlementData.main_sub_transfer_deposit_number =
            element.main_sub_transfer_deposit_number;
          settlementData.main_sub_transfer_deposit_flag =
            element.main_sub_transfer_deposit_flag;

          settlementData.main_sub_transfer_withdrawal_amount =
            element.main_sub_transfer_withdrawal_amount;
          settlementData.main_sub_transfer_withdrawal_number =
            element.main_sub_transfer_withdrawal_number;
          settlementData.main_sub_transfer_withdrawal_flag =
            element.main_sub_transfer_withdrawal_flag;

          settlementData.remittance_between_individuals_deposit_amount =
            element.remittance_between_individuals_deposit_amount;
          settlementData.remittance_between_individuals_deposit_number =
            element.remittance_between_individuals_deposit_number;
          settlementData.remittance_between_individuals_deposit_flag =
            element.remittance_between_individuals_deposit_flag;

          settlementData.remittance_between_individuals_withdrawal_amount =
            element.remittance_between_individuals_withdrawal_amount;
          settlementData.remittance_between_individuals_withdrawal_number =
            element.remittance_between_individuals_withdrawal_number;
          settlementData.remittance_between_individuals_withdrawal_flag =
            element.remittance_between_individuals_withdrawal_flag;

          settlementData.settlement_iss_fee = element.settlement_iss_fee;

          settlementData.atm_fee_amount = element.atm_fee_amount;
          settlementData.atm_fee_number = element.atm_fee_number;
          settlementData.atm_fee_flag = element.atm_fee_flag;

          settlementData.atm_deposit_amount = element.atm_deposit_amount;
          settlementData.atm_deposit_number = element.atm_deposit_number;
          settlementData.atm_deposit_flag = element.atm_deposit_flag;

          settlementData.overseas_fee_amount = element.overseas_fee_amount;
          settlementData.overseas_fee_number = element.overseas_fee_number;
          settlementData.overseas_fee_flag = element.overseas_fee_flag;

          settlementData.card_issuing_fee_amount =
            element.card_issuing_fee_amount;
          settlementData.card_issuing_fee_number =
            element.card_issuing_fee_number;
          settlementData.card_issuing_fee_flag = element.card_issuing_fee_flag;

          settlementData.card_reissue_fee_amount =
            element.card_reissue_fee_amount;
          settlementData.card_reissue_fee_number =
            element.card_reissue_fee_number;
          settlementData.card_reissue_fee_flag = element.card_reissue_fee_flag;

          settlementData.pin_notification_fee_amount =
            element.pin_notification_fee_amount;
          settlementData.pin_notification_fee_number =
            element.pin_notification_fee_number;
          settlementData.pin_notification_fee_flag =
            element.pin_notification_fee_flag;

          settlementData.report_fee_amount = element.report_fee_amount;
          settlementData.report_fee_number = element.report_fee_number;
          settlementData.report_fee_flag = element.report_fee_flag;

          settlementData.annual_fede_amount = element.annual_fede_amount;
          settlementData.annual_fede_number = element.annual_fede_number;
          settlementData.annual_fede_flag = element.annual_fede_flag;

          settlementData.renewal_fee_amount = element.renewal_fee_amount;
          settlementData.renewal_fee_number = element.renewal_fee_number;
          settlementData.renewal_fee_flag = element.renewal_fee_flag;

          settlementData.deposit_fee_amount = element.deposit_fee_amount;
          settlementData.deposit_fee_number = element.deposit_fee_number;
          settlementData.deposit_fee_flag = element.deposit_fee_flag;

          settlementData.otasuke_charge_fee_amount =
            element.otasuke_charge_fee_amount;
          settlementData.otasuke_charge_fee_number =
            element.otasuke_charge_fee_number;
          settlementData.otasuke_charge_fee_flag =
            element.otasuke_charge_fee_flag;

          settlementData.atm_deposit_fee_amount =
            element.atm_deposit_fee_amount;
          settlementData.atm_deposit_fee_number =
            element.atm_deposit_fee_number;
          settlementData.atm_deposit_fee_flag = element.atm_deposit_fee_flag;

          settlementData.credit_charge_fee_amount =
            element.credit_charge_fee_amount;
          settlementData.credit_charge_fee_number =
            element.credit_charge_fee_number;
          settlementData.credit_charge_fee_flag =
            element.credit_charge_fee_flag;

          settlementData.atm_deposit_fee_amount2 =
            element.atm_deposit_fee_amount2;
          settlementData.atm_deposit_fee_number2 =
            element.atm_deposit_fee_number2;
          settlementData.atm_deposit_fee_flag2 = element.atm_deposit_fee_flag2;

          settlementData.refund_fee_amount = element.refund_fee_amount;
          settlementData.refund_fee_number = element.refund_fee_number;
          settlementData.refund_fee_flag = element.refund_fee_flag;

          this.userSettlementsArray.push(settlementData);
        } catch (error) {
          err = true;
        }
        if (index == array.length - 1) {
          if (!err) {
            await this.writeData();
          } else {
            this.closeLoading();
            this.errormsg = "このファイル形式はインポートできません。";
            this.$modal.show("error");
          }
        }
      });
    },
    async buildData(results) {
      this.resetImportArray();
      let csvFieldsValidated = this.verifyCsvFields(results);
      if (csvFieldsValidated) {
        // if csvFields are all complete check data status on firestore
        const applicationUsersSnapshot = await this.db
          .collection("applicationUsers")
          .limit(1)
          .get();
        let newerData = false;
        if (!applicationUsersSnapshot.empty) {
          // Data already existing
          // if not empty get date_created and check if newer than file
          let yearCSV = results.data[0].date_created.slice(0, 4);
          let monthCSV = results.data[0].date_created.slice(4, 6);
          let yearFirestore = applicationUsersSnapshot.docs[0]
            .data()
            .date_created.slice(0, 4);
          let monthFirestore = applicationUsersSnapshot.docs[0]
            .data()
            .date_created.slice(4, 6);
          let dateFirestore = new Date(yearFirestore + "-" + monthFirestore);
          let dateCSV = new Date(yearCSV + "-" + monthCSV);
          newerData = dateFirestore <= dateCSV;
          if (newerData) {
            // If data is more recent import
            this.fillArray(results);
          } else {
            // Outdated data display already imported modal
            this.closeLoading();
            this.errormsg = "このファイルは既にインポートされました";
            this.$modal.show("error");
          }
        } else {
          // no data existing
          // Build Data
          this.fillArray(results);
        }
      } else {
        // Display format error modal
        this.closeLoading();
        this.errormsg = "このファイル形式はインポートできません。";
        this.$modal.show("error");
      }
    },
    async writeData() {
      this.$modal.hide("duplicatedEntry");
      let batch;
      let total = 0;
      let operationCount = 0;
      let applicationOperation = 0;
      let settlementsOperation = 0;
      batch = this.db.batch();
      for (let element of this.applicationUsersArray) {
        if (operationCount == 250) {
          await batch.commit();
          applicationOperation += operationCount;
          operationCount = 0;
          batch = this.db.batch();
        }
        let applicationUsersRef = this.db
          .collection("applicationUsers")
          .doc(element.contract_number);
        batch.set(applicationUsersRef, element, {
          merge: true,
        });
        operationCount++;
      }
      applicationOperation += operationCount;
      await batch.commit();

      operationCount = 0;
      batch = this.db.batch();
      for (let element of this.userSettlementsArray) {
        if (operationCount == 250) {
          await batch.commit();
          settlementsOperation += operationCount;
          operationCount = 0;
          batch = this.db.batch();
        }
        let docId =
          element.contract_number + "-" + element.year + "-" + element.month;
        let settlementRef = this.db.collection("userSettlements").doc(docId);
        batch.set(settlementRef, element, {
          merge: true,
        });
        operationCount++;
      }

      settlementsOperation += operationCount;
      await batch.commit();

      operationCount = 0;
      batch = this.db.batch();
      for (let element of this.logArray) {
        if (operationCount == 250) {
          await batch.commit();
          operationCount = 0;
          batch = this.db.batch();
        }
        //let docId = element.contract_number + "-" + element.customer_update_day;
        let logRef = this.db.collection("importLog").doc();
        batch.set(logRef, element, {
          merge: true,
        });
        operationCount++;
      }

      await batch.commit();

      total = (applicationOperation + settlementsOperation) / 2;
      this.importCount = total;
      this.closeLoading();
      this.$modal.show("confirm");
      this.loadCollection();
    },
    showModal() {
      if (this.importCount !== 0) {
        this.$modal.show("confirm");
      } else {
        this.$modal.show("duplicatedEntry");
      }
    },
    loadPointUsers() {
      this.init();
      this.loading = true;
      let usersArray = [];
      let query = this.db.collection("userSettlements");
      let startDate = new Date("2020-10-01T00:00:00+09:00");
      let endDate = new Date("2020-11-30T12:00:00+09:00");
      query
        .where("date_created_dateformat", ">=", startDate)
        .where("date_created_dateformat", "<=", endDate)
        //.orderBy("created_at", "desc")
        .get()
        .then(async (snapshot) => {
          snapshot.forEach(async (doc) => {
            let data = doc.data();
            let sum =
              parseInt(data.credit_charge_amount) +
              parseInt(data.atm_deposit_amount) +
              parseInt(data.transfer_deposit_amount);
            if (usersArray[data.contract_number] == undefined)
              usersArray[data.contract_number] = 0;
            usersArray[data.contract_number] += sum;
          });
          for (let key in usersArray) {
            if (usersArray[key] >= 5000) {
              let data = this.usersCache[key];
              if (data !== undefined && data.valid_member_flag == "1") {
                this.users.push({
                  契約番号: data.contract_number,
                  代表契約番号: data.representative_contract_number,
                  電話番号: data.telephone,
                  携帯電話番号: data.mobile,
                  カナ英字氏名: data.kana_name,
                  漢字氏名: data.kanji_name,
                  POPINFOID: data.popinfoId,
                });
                this.usersCsv.push({
                  contract_number: data.contract_number,
                  kana_name: data.kana_name,
                  kanji_name: data.kanji_name,
                });
              }
            }
          }
          this.fileName = "pointUsers";
          this.csvCurrentFields = {
            contract_number: { title: "契約番号" },
            kana_name: { title: "カナ英字氏名" },
            kanji_name: { title: "漢字氏名" },
          };
          //sessionStorage.managementFileName=this.fileName;
          //sessionStorage.setItem("csvFieldsApp", JSON.stringify(this.csvCurrentFields));
          //sessionStorage.setItem("users", JSON.stringify(this.users));
          //sessionStorage.setItem("usersCsvManagement", JSON.stringify(this.usersCsv));
          this.loading = false;
        });
    },
    loadCollection(searchParams = null, filter = null) {
      this.init();
      this.loading = true;
      let choysanCollection = [];
      if (this.choysanAccountOnly) {
        let querychoysanData = this.db
          .collection("users")
          .where("status", "==", "1");
        querychoysanData.get().then((snapshot) => {
          snapshot.forEach((doc) => {
            if (doc.exists) {
              var data = doc.data();
              if (data.phone !== "" && data.phone !== undefined) {
                choysanCollection[data.phone] = data;
              }
            }
          });
        });
      }
      let query = this.db.collection("applicationUsers");
      if (searchParams !== null) {
        for (const [key, value] of Object.entries(searchParams)) {
          if (value !== "") {
            query = query.where(key, "==", value);
          }
        }
      }
      if (filter == "popinfoId") {
        query = query.where("popinfoId", "!=", "");
        this.csvCurrentFields = {
          POPINFOID: { title: "POPINFOID" },
        };
        this.fileName = "popinfoIdLists";
      } else {
        query.orderBy("contract_number", "asc");
        this.csvCurrentFields = this.csvFields;
        this.fileName = this.tsvFormat.bankitInfo.fileName;
      }
      query
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            if (doc.exists) {
              var data = doc.data();
              if (filter == null) {
                this.users.push({
                  契約番号: data.contract_number,
                  代表契約番号: data.representative_contract_number,
                  電話番号: data.telephone,
                  携帯電話番号: data.mobile,
                  カナ英字氏名: data.kana_name,
                  漢字氏名: data.kanji_name,
                  契約日:data.contract_date,
                  更新日:data.contract_update_day
                });
                this.usersCache[data.contract_number] = {
                  contract_number: data.contract_number,
                  representative_contract_number:
                    data.representative_contract_number,
                  telephone: data.telephone,
                  mobile: data.mobile,
                  kana_name: data.kana_name,
                  kanji_name: data.kanji_name,
                  popinfoId: data.popinfoId,
                  valid_member_flag: data.valid_member_flag,
                };
                delete data.mobile_0;
                delete data.telephone_0;
                this.usersCsv.push(data);
              }
              if (filter == "popinfoId") {
                if (data.valid_member_flag == "1") {
                  this.users.push({
                    契約番号: data.contract_number,
                    代表契約番号: data.representative_contract_number,
                    電話番号: data.telephone,
                    携帯電話番号: data.mobile,
                    カナ英字氏名: data.kana_name,
                    漢字氏名: data.kanji_name,
                    POPINFOID: data.popinfoId,
                  });
                  this.usersCsv.push({
                    契約番号: data.contract_number,
                    POPINFOID: data.popinfoId,
                    mobile: data.mobile,
                  });
                }
              }
            }
          });
        })
        .then(() => {
          //sessionStorage.setItem("users", JSON.stringify(this.users));
          //sessionStorage.setItem("usersCache", JSON.stringify(this.usersCache));
          //sessionStorage.setItem("usersCsvManagement", JSON.stringify(this.usersCsv));
          //sessionStorage.name = this.name;
          //sessionStorage.kanjiname = this.kanjiname;
          //sessionStorage.contract = this.contract;
          //sessionStorage.contractrep = this.contractrep;
          //sessionStorage.mobile = this.mobile;
          //sessionStorage.telephone = this.telephone;
          //sessionStorage.setItem("saved", new Date().getTime());
          if (filter == "popinfoId") {
            // manual sort of the array because firestore doesn't allow query on a field and sorting on a different field
            let temp = this.users.sort(this.orderByContractNumber);
            this.users = temp;
            let tempcsv = this.usersCsv.sort(this.orderByContractNumber);
            this.usersCsv = tempcsv;
          }
          if (this.choysanAccountOnly) {
            let temp = this.users.filter((user) => {
              return choysanCollection["0" + user.携帯電話番号] !== undefined;
            });
            this.users = temp;
            let tempCsv = this.usersCsv.filter((user) => {
              let choysanData = choysanCollection["0" + user.mobile];
              if (choysanData !== undefined) {
                user.pid = choysanData.pid == undefined ? "" : choysanData.pid;
                user.redirectId =
                  choysanData.redirectId == undefined
                    ? ""
                    : choysanData.redirectId;
                user.zairyuuShikaku =
                  choysanData.zairyuuShikaku == undefined
                    ? ""
                    : choysanData.zairyuuShikaku;
                user.zairyuOther =
                  choysanData.zairyuOther == undefined
                    ? ""
                    : choysanData.zairyuOther;
                let pref = this.prefs.find((element) => {
                  return element.code == choysanData.pref_code;
                });
                user.prefecture = pref == undefined ? "" : pref.name;
                user.created_at_choysan = new Date(
                  choysanData.created_at.seconds * 1000
                );
                user.source = choysanData.source;
                let country = this.countries.find((element) => {
                  return element.code == choysanData.country_code;
                });
                user.country = country == undefined ? "" : country.name;
                user.status = choysanData.status;
                user.firstname = choysanData.first_name_en;
                user.lastname = choysanData.last_name_en;
                user.middlename = choysanData.middle_name_en;
                return true;
              } else return false;
            });
            this.fileName = "BankitUsersWithChoysanAccount";
            this.csvCurrentFields = this.csvFieldsChoysan;
            // add choysan fields to the CSV
            this.usersCsv = tempCsv;
          }
          //sessionStorage.managementFileName=this.fileName;
          //sessionStorage.setItem("csvFieldsApp", JSON.stringify(this.csvCurrentFields));
          this.loading = false;
          /*             if(filter=="staticFormat"){
                this.addPointToUsers();
            } */
        });
    },
    findNewData(oldData, newData) {
      let differentFields = [];
      /*       for (const [key] of Object.entries(oldData)) {
        if (oldData[key] !== newData[key]) {
          differentFields.push(key);
        }
      } */
      if (oldData["address1"] !== newData["address1"])
        differentFields.push("address1");
      if (oldData["address2"] !== newData["address2"])
        differentFields.push("address2");
      if (oldData["telephone"] !== newData["telephone"])
        differentFields.push("telephone");
      if (oldData["mobile"] !== newData["mobile"])
        differentFields.push("mobile");
      if (oldData["occupation"] !== newData["occupation"]) {
        differentFields.push("occupation");
      }
      if (
        newData["occupation"] == "10" && // 10 = その他
        oldData["occupation_other"] !== newData["occupation_other"]
      )
        differentFields.push("occupation_other");
      return differentFields;
    },
  },
};
</script>
